import { createModulePage } from '../../../components/generic/createModulePage';
import { initializeModule } from '../../../utils/configInit';
import { complaintInvestigationCategoryConfig } from './complaintInvestigationCategoryConfig';
import { createComplaintInvestigationCategoryValidation } from './complaintInvestigationCategoryValidation';
const { config: initializedConfig } = initializeModule(complaintInvestigationCategoryConfig, createComplaintInvestigationCategoryValidation);
const ComplaintInvestigationCategoryPage = createModulePage(initializedConfig, { displayName: 'ComplaintInvestigationCategoryPage', description: 'Investigation Category Management System' });
export default ComplaintInvestigationCategoryPage;

